import React from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { MediaListVideoItem } from '~admin/view/components/ui/form/fields/media/media-list/media-list-video-item.component';
import { Column } from '~common/components/column.component';

interface Props {
  mediaList: MediaData[];
  onMediaSelected?: (media: MediaData) => void;
}

export const MediaListVideo: React.FunctionComponent<Props> = ({ mediaList, onMediaSelected }) => {
  return (
    <Container>
      {mediaList?.map((media) => (
        <MediaListVideoItem key={media.id} media={media} onMediaSelected={onMediaSelected} />
      ))}
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-list/media-list-video.component.tsx